module.exports = __webpack_public_path__ + "img/audio_classify6.8aaf7f2a.png";